import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import CreateOrEditTemplatePage from './CreateOrEditTemplatePage'
import { receiveTemplate, readTemplate } from '../../actions/template'
import { stepperGoTo } from 'actions/view'
import { read } from 'actions/data'

export default connect(
  (state, { match, templateID }) => ({
    // templatesById: state.email.templatesById,
    templateID: templateID || state.email.templateID,
    template:
      state.email.templatesById?.[match?.params?.templateId] ||
      state.data?.['sms/template']?.[match.params.templateId],
  }),
  dispatch =>
    bindActionCreators(
      { receiveTemplate, readTemplate, stepperGoTo, read },
      dispatch,
    ),
)(
  withStyles(theme => ({
    // ...other styles for the pages
    content: {
      padding: '60px 24px 0',
      maxWidth: '1490px',
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
  }))(CreateOrEditTemplatePage),
)
